module.exports = __webpack_public_path__ + "img/RT.2d74719f.png";